import { Grid, Box, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import Configs from "../../constants/Configs";
import DialogError from "../../components/CustomDialog/DialogWait";
import { getData, clearData, callChoice } from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import { makeStyles } from "@mui/styles";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { isEmpty } from "lodash";
import GlobalApi from "../../utils/GlobalApi";

const useStyle = makeStyles({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  title_row: {
    color: "var(--primary)",
    fontFamily: "DB Heavent",
    marginTop: "25px",
    fontSize: "24px",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
  subTitle: {
    fontFamily: "DB Heavent",
    fontSize: "18px",
    color: "var(--primary)",
    marginTop: "6px",
  },
  radioCustom: {
    width: "100% !important",
    "& label": {
      marginLeft: "0px !important",
      borderBottom: "solid 1px #ccc",
    },
  },
  imgSign: {
    display: "block",
    width: "100%",
    margin: "auto",
  },
  borderCustom: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "2px dashed var(--lemon)",
    borderRadius: "4px",
    width: "90%",
    margin: "auto",
  },
});
const ExampleSign = (props) => {
  const classes = useStyle();
  const [isCheck, setIscheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [translations, setTranslations] = useState("");
  const [jumpPage, setJumpPage] = useState(false);
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        clearData("back_form_ats");
      }
    });
  }, []);

  const handleNext = async () => {
    props.history.push("/attach_sign");
  };

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.sign?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) =>
              e ? props.history.push("/invest_info_asset") : ""
            }
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btn={"ตกลง"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.sign}
                        clickBack={(e) =>
                          props.history.push("/invest_info_asset")
                        }
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.sign?.title}
                          />
                          <ScrollBarComponent
                            isCheck={isCheck}
                            onChangeCheck={setIscheck}
                            content={
                              <Box>
                                <Typography className="font-title font-20">
                                  กรุณาลงลายมือชื่อ 2 ครั้ง บนกระดาษเปล่าสีขาว
                                  เพื่อเก็บภาพถ่าย และอัปโหลดเข้าระบบ
                                </Typography>
                                <div className={classes.subTitle}>
                                  (กรณีใช้งานเว็บบราวเซอร์บน PC ให้ทำการอัปโหลด
                                  ไฟล์ภาพ JPG, PNG)
                                </div>
                                <Typography className="font-title font-20 pt-4">
                                  ตัวอย่าง
                                </Typography>
                                <Grid className="pt-4 pb-4">
                                  <Box className={classes.borderCustom}>
                                    <img
                                      className={classes.imgSign}
                                      src={"images/ExampleSign.png"}
                                    />
                                  </Box>
                                </Grid>
                              </Box>
                            }
                          ></ScrollBarComponent>{" "}
                          <ButtonRight
                            text={translations?.[lang]?.sign?.next}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(ExampleSign);
